import {
  GET_RESET_STATUS,
  SET_RESET_STATUS,
} from "../constants/reset-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RESET_STATUS:
      const { status } = action;
      return { ...state, status };
    default:
      return state;
  }
};
